import { render, staticRenderFns } from "./new-user.vue?vue&type=template&id=4d159316&"
import script from "./new-user.vue?vue&type=script&lang=js&"
export * from "./new-user.vue?vue&type=script&lang=js&"
import style0 from "./new-user.vue?vue&type=style&index=0&id=4d159316&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports